export default __webpack_public_path__ + "static/0004-ffaa06fb349c0c7eae845b45435c3d80.png";